var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.37321 0C0.617945 0 0 0.61875 0 1.375V20.625C0 21.3812 0.617945 22 1.37321 22H15.1053C15.8606 22 16.4785 21.3812 16.4785 20.625V5.5L10.9857 0H1.37321Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3586 5.5H16.4782L10.9854 0V4.125C10.9854 4.88125 11.6033 5.5 12.3586 5.5Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileGroup);
export default __webpack_public_path__ + "static/media/FileGroup.c5434bab98d99deafef94e77f7982feb.svg";
export { ForwardRef as ReactComponent };